import MabinsoModel from '../../app/models/MabinsoModel';
import Globals from '../../../utils/Globals';

class ActionUserModel extends MabinsoModel {
    urlRoot = () => Globals.baseUrl + 'actions/getUserAction';
}
export default ActionUserModel;
